import { html } from "lit";
import { QuickActionItem } from "./quick-action-item";

export const template = (props: QuickActionItem) => {
  return html`
    <dss-action-menu-item @click=${props.callbackFn} notificationsstate="error" rightIcon=${props.icon} label=${props.label}></dss-action-menu-item>
  `;
};
